const stripPostalCode = value => {
  if (!value) {
    return '';
  }
  return value
    .replace(/\b\d{5}(?:-\d{4})?\b/g, '')
    .replace(/\s+/g, ' ')
    .trim();
};

const stripCountry = value => {
  if (!value) {
    return '';
  }
  return value
    .replace(/\b(United States(?: of America)?|USA|US)\b/gi, '')
    .replace(/\s+/g, ' ')
    .trim();
};

/**
 * Format a US location as "City, State".
 * Falls back to the original address when values can't be resolved.
 */
export const formatUSCityState = ({ city, state, fallbackAddress = '' }) => {
  const cleanedCity = stripCountry((city || '').trim());
  const cleanedState = stripPostalCode(stripCountry((state || '').trim()));

  if (cleanedCity && cleanedState) {
    return `${cleanedCity}, ${cleanedState}`;
  }
  return fallbackAddress;
};

/**
 * Parse generic address strings and reduce them to "City, State" where possible.
 * Examples:
 * - "Austin, Texas, United States" -> "Austin, Texas"
 * - "123 Main St, Austin, TX 78701, USA" -> "Austin, TX"
 */
export const formatUSCityStateFromAddress = address => {
  if (!address || typeof address !== 'string') {
    return address;
  }

  const parts = address
    .split(',')
    .map(part => part.trim())
    .filter(Boolean);

  if (parts.length < 2) {
    return address;
  }

  const hasStreetPrefix =
    /\d/.test(parts[0]) || /\b(st|street|ave|avenue|rd|road|blvd|suite)\b/i.test(parts[0]);
  const city = hasStreetPrefix ? parts[1] : parts[0];
  const stateCandidateIndex = hasStreetPrefix ? 2 : 1;
  const state = parts[stateCandidateIndex] || '';

  return formatUSCityState({ city, state, fallbackAddress: address });
};
